import React, { useState } from 'react';
import { Player, PlayerEvent } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';
import { HealthReferenceSection } from '@screens/HealthPages/HealthReferenceSection';

interface GutOralDetailsCardProps {
  mainText: string;
  isMainTextPercentage?: boolean;
  subText: string;
  subTextColor?: string;
  videoSrc: any;
  fallBackVdo: string;
  scoreId?: number;
  'data-testid'?: string;
}

export const GutOralDetailsCard: React.FC<GutOralDetailsCardProps> = ({
  mainText,
  subText,
  subTextColor,
  isMainTextPercentage,
  videoSrc,
  fallBackVdo,
  scoreId,
  'data-testid': testId,
}) => {
  const [isS3Loaded, setIsS3Loaded] = useState(false);

  const handleOnEvent = (e: PlayerEvent) => {
    if (e === 'load') {
      setIsS3Loaded(true);
    }
  };

  return (
    <div data-testid={testId} className="h-full cursor-auto select-none">
      {videoSrc && (
        <>
          <div 
            data-testid={`${testId}-videoContainer`}
            className="h-[26rem] relative"
          >
            <div 
              data-testid={`${testId}-videoOverflow`}
              className="absolute inset-0 overflow-hidden"
            >
              {!isS3Loaded && (
                <Player
                  data-testid={`${testId}-fallbackVideoPlayer`}
                  autoplay
                  loop
                  src={fallBackVdo}
                  className="rounded-lg object-cover"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                  }}
                />
              )}
              <Player
                data-testid={`${testId}-videoPlayer`}
                autoplay
                loop
                src={videoSrc}
                className="rounded-lg object-cover"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: '100%',
                  display: isS3Loaded ? 'block' : 'none',
                }}
                onEvent={handleOnEvent}
              />
            </div>
            <div 
              data-testid={`${testId}-textContent`}
              className="absolute inset-0 flex flex-col justify-center items-center"
            >
              <p
                data-testid={`${testId}-mainText`}
                className={cn(
                  'dark text-primary font-serif',
                  isMainTextPercentage
                    ? 'typography-num-xlarge'
                    : 'typography-d1',
                )}
              >
                {mainText}
              </p>
              <p
                data-testid={`${testId}-subText`}
                className="dark typography-body text-primary"
                style={{ color: subTextColor }}
              >
                {subText}
              </p>
            </div>
          </div>
          {scoreId && (
            <div 
              data-testid={`${testId}-referenceSection`}
              className="text-center flex items-center justify-center"
            >
              <HealthReferenceSection 
                data-testid={`${testId}-healthReference`}
                variant="light" 
                scoreId={scoreId} 
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
